<footer>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-2">
                <img src="assets/images/edu_logo.png" class="edu_logo" alt="logo">
                
            </div>
            <!-- <div class="col-md-10">
                <p class="copy-line">EduCred is providing this e-verification service on behalf of the University of Mumbai, on the basis of records provided by the University. EduCred is a division of SecUR Credentials Ltd.</p>
            </div> -->
            <!-- <div class="col-md-2">
                <h2 class="footer-hd">The Company</h2>
                <p class="footer-line"><a href="#" data-toggle="modal" data-target="#aboutModal">About EduCred</a></p>
                <p class="footer-line"><a href="#">Privacy Policy</a></p>
                <p class="footer-line"><a href="#">Terms & Condition</a></p>
            </div>
            <div class="col-md-2">
                <h2 class="footer-hd">Services</h2>
                <p class="footer-line"><a href="#">e-verification</a></p>
                <p class="footer-line"><a href="#">e-attestation</a></p>
                <p class="footer-line"><a href="#">Duplicate Document</a></p>
            </div>
            <div class="col-md-2">
                <h2 class="footer-hd">Social</h2>
                <p class="footer-line"><a href="#">Linkedin</a></p>
                <p class="footer-line"><a href="#">Facebook</a></p>
                <p class="footer-line"><a href="#">Twitter</a></p>
            </div> -->
            <!-- <div class="col-md-10">
                <p class="copy-line">EduCred is providing this e-verification service on behalf of the University of Mumbai, on the basis of records provided by the University. EduCred is a division of SecUR Credentials Ltd.</p>
            </div> -->
        </div>
        <!-- <div class="line"></div>
        <div class="row">
            <div class="col-md-12">
                
            </div>
        </div> -->
    </div>
</footer>

<div class="modal fade" id="aboutModal" tabindex="-1" role="dialog" aria-labelledby="aboutModal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="aboutModal">About EduCred</h5>
        </div>
        <div class="modal-body">
          <div class="row">
              <div class="col-md-12">
                  <ul class="terms-ul">
                      <li>EduCred is providing this e-verification service on behalf of the University of Mumbai, on the basis of records provided by the University.</li>
                      <li>EDUCRED is a service of providing e-verification and e-attestation of education  documents on behalf of the University to various applicants and requestors. It is fully owned and operated by SecUR Credentials Ltd. This service is provided as part of a contractual agreement between SecUR Credentials Ltd. and the University.</li>
                      <li>All details provided as part of this service have been compiled based on information shared by the University. The report is not to be reproduced or used for any other purpose, in whole or part, without prior written consent in each specific instance.</li>
                      <li>Do note that we are not the source of the data gathered and our findings are based on the information made available to us, therefore, we cannot guarantee the accuracy of the information collected. Should additional information or documentation become available to us, which impacts the conclusions in our reports, we reserve the right to amend our findings in our report accordingly.</li>
                      <li>We expressly disclaim all responsibility or liability for any costs, damages, losses, liabilities, expenses, incurred by anyone as a result of circulation, publication, reproduction or use of our reports contrary to the provisions of this paragraph. Due to factors beyond our control, it may be possible that we are unable to get all the necessary information requested for and the same will be communicated to the applicant / user. </li>
                  </ul>
              </div>
          </div>
        </div>
      </div>
    </div>
</div>